import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
  data() {
    return {
      StartStopOption: {},
      workOption: {},
      faultOption: {},
      StartStopOptionLoading: false,
      workOptionLoading: false,
      faultOptionLoading: false,
      orgId: '',
      isValue: true,
      isShow: true,
      isDisplay: true,
      formInline: {
        driverNum: '',
        name: ''
      },
      height: '500',
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false,
        mutiSelect: true, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "driverNum",
          label: this.$t('DriverAnalysis.driverNum'),
          align: "center",
        },
        {
          prop: "name",
          label: this.$t('DriverAnalysis.name'),
          align: "center",
        },
        {
          prop: "orgName",
          label: this.$t('DriverAnalysis.orgName'),
          align: "center",

        },
        {
          prop: "workTime",
          label: this.$t('DriverAnalysis.workTime'),
          align: "center",

        },
        {
          prop: "workTimeH",
          label: this.$t('VehicleAnalysis.workTimeH'),
          align: "center",
        },
        {
          prop: "cardCount",
          label: this.$t('DriverAnalysis.cardCount'),
          align: "center",

        },
        {
          prop: "cardCountH",
          label: this.$t('DriverAnalysis.cardCountH'),
          align: "center",

        },
        {
          prop: "alarmCount",
          label: this.$t('DriverAnalysis.alarmCount'),
          align: "center",

        },
        {
          prop: "alarmCountH",
          label: this.$t('DriverAnalysis.alarmCountH'),
          align: "center",

        },
      ],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1,
      pageSize: 10, 
      total: 1, 
    }
  },
  components: {
    linegraph,
    iTable,
    IPagination
  },
  methods: {
    getFaultTotal() {
      this.faultOptionLoading = true
      let cars = [];
      let FaultCount = [];
      let param = {
        orgId: this.orgId,
        pageNum: 1,
        pageSize: 10,
        selectTimeType: 3
      }
      this.$store.dispatch("DriverAnalysis/GET_DRIVERALARMORDER", param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            if (res.data.data.length > 0) {
              this.isValue = true
              res.data.data.map((item, index) => {
                cars.push(`${index + 1}.`+this.$t('DriverAnalysis.driverName')+`:${item.name}`)
                FaultCount.push(item.alarmCount)
                this.rankFault(cars, FaultCount)
              })
            } else {
              this.isValue = false
            }

          }
        }
        this.faultOptionLoading = false
      }).catch(err => {
        this.faultOptionLoading = false
      })
    },
    rankFault(cars, FaultCount) {
      let option = {
        grid: {
          left: '0',
          right: '10%',
          top: '10%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#fff',
            }
          },
          axisTick: {
            show: false
          },
          data: cars.slice(0, 10).reverse()
        },
        series: [{
          data: FaultCount.slice(0, 10).reverse(),
          type: 'bar',
          barCategoryGap: '50%',
          label: {
            normal: {
              show: true,
              position: 'right',
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              barBorderRadius: 15,
              color: new echarts.graphic.LinearGradient(
                0, 0, 1, 0,
                [
                  { offset: 0, color: '#fc5a62' },                   
                  { offset: 1, color: '#f69d70' },                   
                ]
              )
            },
          }
        }]
      }
      this.faultOption = option
    },

    getWorkTotal() {
      this.workOptionLoading = true
      let carList = [];
      let workTime = [];
      let param = {
        orgId: this.orgId,
        pageNum: 1,
        pageSize: 10,
        selectTimeType: 3
      }
      this.$store.dispatch("DriverAnalysis/GET_DRIVERTIMEORDER", param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            if (res.data.data.length > 0) {
              this.isShow = true
              res.data.data.map((item, index) => {
                carList.push(`${index + 1}.`+this.$t('DriverAnalysis.driverName')+`:${item.name}`)
                workTime.push(item.workTime)
                this.rankWork(carList, workTime)
              })
            } else {
              this.isShow = false
            }
          }
        }
        this.workOptionLoading = false
      }).catch(err => {
        this.workOptionLoading = false
      })
    },
    rankWork(carList, workTime) {
      let option = {
        grid: {
          left: '0',
          right: '10%',
          top: '10%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#fff',
            }
          },
          axisTick: {
            show: false
          },
          data: carList.slice(0, 10).reverse()
        },
        series: [{
          data: workTime.slice(0, 10).reverse(),
          type: 'bar',
          barCategoryGap: '50%',
          label: {
            normal: {
              show: true,
              position: 'right',
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              barBorderRadius: 15,
              color: new echarts.graphic.LinearGradient(
                0, 0, 1, 0,
                [
                  { offset: 0, color: '#8e70f9' },                   
                  { offset: 1, color: '#da609f' },                   
                ]
              )
            },
          }
        }]
      }
      this.workOption = option
    },

    getRankStopTotal() {
      this.StartStopOptionLoading = true
      let Car = [];
      let StartStop = [];
      let param = {
        orgId: this.orgId,
        pageNum: 1,
        pageSize: 10,
        selectTimeType: 3
      };
      this.$store.dispatch("DriverAnalysis/GET_DRIVERCARDORDER", param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            if (res.data.data.length > 0) {
              this.isDisplay = true
              res.data.data.map((item, index) => {
                Car.push(`${index + 1}.`+this.$t('DriverAnalysis.driverName')+`:${item.name}`)
                StartStop.push(item.cardCount)
                this.RankStopCount(Car, StartStop)
              })
            } else {
              this.isDisplay = false
            }
          }
        }
        this.StartStopOptionLoading = false
      }).catch(err => {
        this.StartStopOptionLoading = false
      })
    },
    RankStopCount(Car, StartStop) {
      let option = {
        grid: {
          left: '1%',
          right: '10%',
          top: '10%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#fff',
            }
          },
          axisTick: {
            show: false
          },
          data: Car.slice(0, 10).reverse()
        },
        series: [{
          data: StartStop.slice(0, 10).reverse(),
          type: 'bar',
          barCategoryGap: '50%',
          label: {
            normal: {
              show: true,
              position: 'right',
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              barBorderRadius: 15,
              color: new echarts.graphic.LinearGradient(
                0, 0, 1, 0,
                [
                  { offset: 0, color: '#437cfc' },                   
                  { offset: 1, color: '#48e2f9' },                   
                ]
              )
            },
          }
        }]
      }
      this.StartStopOption = option
    },

    getTotalOrderList() {
      let param = {
        orgId: this.orgId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        selectTimeType: 3,
        driverNum: this.formInline.driverNum,
        name: this.formInline.name
      };
      this.$store.dispatch('DriverAnalysis/GET_DRIVERORDERLIST', param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      }).catch(err => { })
    },
    onSearch() {
      this.currentPage = 1
      this.getTotalOrderList()
    },
    onClear() {
      this.formInline.driverNum = ''
      this.formInline.name = ''
      this.getTotalOrderList()
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}//v1/getExportExcel/exportDriverOrderList?orgId=${this.orgId}&selectTimeType=${3}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}//v1/getExportExcel/exportDriverOrderList?orgId=${this.orgId}&selectTimeType=${3}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}`
          location.href = url
        }
      }
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getTotalOrderList();
    },
  }
}
